import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import NoTableData from "components/NoTableData";
import { getRequestTypeTitle } from "helpers/RequestHelper";
import { formatDate } from "helpers/DateHelper";
import Portal from "components/Portal";

const ModelVersionsBLC = ({ tableData, showLink, show, urlPrefix }) => {
  if (!show) return null;
  if (tableData.length) {
    const renderRows = () => {
      return tableData.map((row, i) => {
        const {
          hwversion,
          id,
          formatedtransactionnumber,
          requesttypeid,
          completedat
        } = row;
        const reqType = getRequestTypeTitle(requesttypeid);
        const certDate = formatDate(completedat);
        const linkToRequest = () => {
          if (!showLink) return formatedtransactionnumber;

          return (
            <Portal
              changeCertProgram={"blc"}
              to={`${urlPrefix}requests/${id}`}
              tn={formatedtransactionnumber}
            />
          );
        };

        return (
          <tr key={i}>
            <td>{linkToRequest()}</td>
            <td>{hwversion}</td>
            <td>{reqType}</td>
            <td>{certDate}</td>
          </tr>
        );
      });
    };

    return (
      <div>
        <h3 className="no-margin">Device History</h3>
        <Table responsive striped className="ctia-table">
          <thead>
            <tr>
              <th>Request ID</th>
              <th>HW Version</th>
              <th>Request Type</th>
              <th>Date Certified</th>
            </tr>
          </thead>
          <tbody>{renderRows()}</tbody>
        </Table>
      </div>
    );
  }

  return <NoTableData colSpan={5} />;
};

ModelVersionsBLC.propTypes = {
  tableData: PropTypes.array,
  showLink: PropTypes.bool
};

ModelVersionsBLC.defaultProps = {
  tableData: [],
  showLink: false
};

export default ModelVersionsBLC;
